import { render, staticRenderFns } from "./KCinitialize.vue?vue&type=template&id=2c46eee3&scoped=true&"
import script from "./KCinitialize.vue?vue&type=script&lang=js&"
export * from "./KCinitialize.vue?vue&type=script&lang=js&"
import style0 from "./KCinitialize.vue?vue&type=style&index=0&id=2c46eee3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c46eee3",
  null
  
)

export default component.exports